import { ChevronDownIcon } from "@primer/octicons-react";
import { Button, SelectPanel } from '@primer/react';
import { useEffect, useMemo, useState } from 'react';
import { hocSinhLichSuYTeTypeApi } from '../../api/hocSinhLichSuYTeTypeApi';
import { useCommonContext } from '../../contexts/common';
import { ts_hocsinh_lichsu_yte_type } from '../../models/response/hoc-sinh/ts_hocsinh_lichsu_yte_type';

interface IComboboxLichSuYTeTypeProps {
    isReadonly?: boolean;
    value?: number;
    onValueChanged: (id: number, data?: ts_hocsinh_lichsu_yte_type) => void;
    className?: string;
    isShowClearButton?: boolean;
    preText?: string;
    width?: string | number;
    stylingMode?: 'outlined' | 'filled' | 'underlined';
}

const ComboboxLichSuYTeType = (props: IComboboxLichSuYTeTypeProps) => {
    const [lichSuYTeTypes, setLichSuYTeTypes] = useState<ts_hocsinh_lichsu_yte_type[]>([]);

    const [open, setOpen] = useState(false)
    const [filter, setFilter] = useState('')

    const { translate } = useCommonContext();
    const dataSource = useMemo(() => {
        return lichSuYTeTypes.map(x => ({ id: x.id, text: x.nhom_noi_dung }))
    }, [lichSuYTeTypes])
    const filteredItems = useMemo(() => {
        return dataSource.filter(item => item.text.toLowerCase().includes(filter.toLowerCase()))
    }, [dataSource, filter])
    const selected = useMemo(() => {
        return dataSource.find(x => x.id === props.value)
    }, [dataSource, props.value])

    useEffect(() => {
        handleGetLichSuYTeTypesAsync();
    }, [])

    const setSelected = (selecteds: any) => {
        if (selecteds) {
            const selectedData = lichSuYTeTypes.find(x => x.id === selecteds.id);
            props.onValueChanged(selecteds.id, selectedData)
        }
    }
    const handleGetLichSuYTeTypesAsync = async () => {
        const res = await hocSinhLichSuYTeTypeApi.selectAll();
        if (res.is_success) {
            setLichSuYTeTypes(res.data || [])
        }
    }
    return (
        <SelectPanel
            renderAnchor={({ children, 'aria-labelledby': ariaLabelledBy, ...anchorProps }) => (
                <Button
                   trailingAction={ChevronDownIcon}
                    aria-labelledby={` ${ariaLabelledBy}`}
                    {...anchorProps}
                    sx={{
                        width: '100%',
                        '[data-component="buttonContent"]': {
                            display: 'flex',
                            justifyContent: 'flex-start',
                            gridTemplateAreas: 'none',
                            gridTemplateColumns: 'none',
                            '& > :first-child': {
                                flex: 1,
                                textAlign: 'left'
                            }
                        }
                    }}
                >
                    {children || translate("Chọn loại lịch sử y tế")}
                </Button>
            )}
            title={""}
            placeholderText="Search"
            open={open}
            onOpenChange={setOpen}
            items={filteredItems}
            selected={selected}
            onSelectedChange={setSelected}
            onFilterChange={setFilter}
            showItemDividers={true}
            overlayProps={{ width: 'small', height: 'medium' }}
        />
    );
};

export default ComboboxLichSuYTeType;